import React from 'react';
import { __ } from '../translations';

interface YearTabsProps {
  years: string[];
  activeYear: string;
  setActiveYear: (year: string) => void;
}

const YearTabs: React.FC<YearTabsProps> = ({ years, activeYear, setActiveYear }) => {
  if (!years || years.length === 0) {
    return null;
  }

  // Sort years in descending order (newest first)
  const sortedYears = [...years].sort((a, b) => b.localeCompare(a));

  return (
    <div className="mb-6">
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-8" aria-label="Tabs">
          <button
            onClick={() => setActiveYear('all')}
            className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
              activeYear === 'all'
                ? 'border-blue-500 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            {__('All Years')}
          </button>
          
          {sortedYears.map((year) => (
            <button
              key={year}
              onClick={() => setActiveYear(year)}
              className={`whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm ${
                activeYear === year
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {year}
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default YearTabs;